import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import DataTable from '../ui/table';
import RelatedEditor from './relatedEditor'; // api

import { getAreaTerminals } from '../../api/areaAPI';
var gt = i18n.getFixedT(null, 'app');
var TerminalsRelated = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      terminals = _useState2[0],
      setTerminals = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      editData = _useState4[0],
      setEditData = _useState4[1];

  var id = props.id,
      onClose = props.onClose,
      isOpen = props.isOpen;

  var handleClose = function handleClose() {
    if (!_.isEmpty(editData)) return;
    onClose();
  };

  var handleCloseEdit = function handleCloseEdit() {
    setEditData(null);
  };

  var handleEdit = function handleEdit(row) {
    setEditData({
      id: row.value,
      name: row.text
    });
  }; // const fetchData = () => {
  //     let sort = {field: 'name', desc: false}
  //     getAreaTerminals(contextRoot, false, null, sort).then(result => {
  //         setTerminals(result.content)
  //     })
  // }


  useEffect(function () {
    if (!isOpen) return;
    setTerminals(terminalsList);
  }, [isOpen]);
  var fields = {};

  _.set(fields, 'text', {
    label: gt('system.terminals')
  });

  _.set(fields, 'setting', {
    label: gt('system.edit'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: gt('system.edit'),
        onClick: function onClick() {
          return handleEdit(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt fa-list-alt"
      })));
    }
  });

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  }); // if(_.isEmpty(terminalsList))
  //     return null


  if (isOpen === false) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: gt('system.terminals-related-setting'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: terminals.length > 0 ? terminals : []
  }))), !_.isEmpty(editData) && /*#__PURE__*/React.createElement(RelatedEditor, {
    contextRoot: contextRoot,
    editData: editData,
    type: 'terminals',
    onClose: handleCloseEdit
  }));
});
TerminalsRelated.defaultProps = {
  id: 'g-terminals-related-editor'
};
TerminalsRelated.propTypes = {
  id: PropTypes.string
};
export default TerminalsRelated;